import graphql__019642a97e9dc81b7aed from "./__generated__/ContributorContactButton_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { isUnauthorized, isUnavailable } from "../../Utils/authorizations";
import { useFormatMessageWithCustomization } from "../../Intl/Context";
import { useRoutesContext } from "../../Routes/RoutesContext";
import ButtonLink from "../../Buttons/ButtonLink";
import Button from "../../Buttons/Button";
import Tooltip from "../../Tooltip/Tooltip";

const ContributorContactButton = props => {
  const contribution = useFragment(
    ContributorContactButton_contribution,
    props.contribution
  );

  const { slug: contributionSlug, participativeModule } = contribution;
  const { slug: participativeModuleSlug } = participativeModule;
  const { contributorContactAuthorized } = contribution.authorizations;

  const translateWithCustomization = useFormatMessageWithCustomization(
    participativeModule.visualization.customIntlMessages
  );
  const label = translateWithCustomization(intlMessages.label);

  const { pathFor } = useRoutesContext();

  // Don't display anything if contacting the contributor is not authorized
  if (isUnauthorized(contributorContactAuthorized)) return null;

  const className = classNames(
    "btn",
    "btn-primary-inverse",
    "btn-shadow",
    "btn-sm",
    props.className
  );

  if (isUnavailable(contributorContactAuthorized)) {
    const disabledClassNames = classNames(className, "disabled");

    const { contributorContact: disabledMessage } =
      contribution.authorizations.unauthorizedMessages;

    return (
      <Tooltip show content={disabledMessage}>
        <Button
          type="button"
          className={disabledClassNames}
          label={label}
          iconClassName="fa fa-envelope"
          disabled
          data-contributor-contact-button
        />
      </Tooltip>
    );
  }

  const url = pathFor("contributorContact", {
    participativeModuleSlug,
    contributionSlug
  });

  return (
    <ButtonLink
      href={url}
      className={className}
      label={label}
      iconClassName="fa fa-envelope"
      data-contributor-contact-button
    />
  );
};

const ContributorContactButton_contribution = graphql__019642a97e9dc81b7aed;

export default ContributorContactButton;

const intlMessages = defineMessages({
  label: {
    id: "participativeModule.contributorsContact.buttonLabel",
    defaultMessage: "Contacter le contributeur",
    description: "Libellé du bouton de demande de contact d'un contributeur"
  }
});
